import dayjs from 'dayjs';

import { parseRelativeDateSelection } from '@/utils/parseRelativeDateSelection';

export { parseRelativeDateSelection };

export const parseSelectedToIso = (params: {
  startPoint: number | undefined;
  comparisonDate: Date | null;
  comparisonType: string;
  compareTo: string;
  compareToUnit: string;
}): string => {
  const { startPoint, comparisonDate, comparisonType, compareTo, compareToUnit } = params;
  let selectedDateString = '';
  if (comparisonDate && comparisonType === 'absolute') {
    selectedDateString = dayjs(comparisonDate).format('YYYY-MM-DD');
  }
  if (compareTo.length > 0 && comparisonType === 'relative') {
    const relativeDate = parseRelativeDateSelection(Number(compareTo), compareToUnit, startPoint);
    selectedDateString = dayjs(relativeDate).format('YYYY-MM-DD');
  }
  return selectedDateString;
};
